import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'
import { AdverseMediaListRequest } from '~bank-adverse-media/types'

export const adverseMediaListQueryOptions = (deps: Partial<AdverseMediaListRequest>) =>
  queryOptions({
    queryKey: ['adverseMediaList', deps],
    queryFn: () => Request.post(Request.urls.bank.adverseMediaList, { ...deps }),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })
